module.exports = __webpack_public_path__ + "img/2-2.3ac2aa2e.svg";